import React from 'react'
import Footer from '../pages/Footer'
import Header from './Header';
import WhyNestora from './WhyNestora';
import BestSeller from './BestSeller';


const Home = () => {
  
  return (
    <div>
        <Header/>
        <WhyNestora/>
        <BestSeller/>
        <Footer/>
    </div>
  )
}

export default Home